// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"4792f5c9","153":"26cb94ca","451":"3375fd69","498":"2f7c03a3","608":"6d5fcbd9","749":"c18ab8fa","758":"3f67e9b3","959":"da0d6231"}[chunkId] + ".chunk.js";
};